import {
  APPLE_STORE,
  GOOGLE_PLAY,
  PRODUCT_PLATFORM_ANDROID,
  PRODUCT_PLATFORM_APPLE,
} from "@/const.ts";

export const getAppStoreName = (platform: string) => {
  if (platform === PRODUCT_PLATFORM_APPLE) {
    return APPLE_STORE;
  } else if (platform === PRODUCT_PLATFORM_ANDROID) {
    return GOOGLE_PLAY;
  }
  return "";
};
